/**
 * Auto-OCR countdown gate for the kiosk camera lane.
 *
 * A previous bug reset the 5s countdown on every successful OCR poll, so the
 * entry/exit action never fired while the plate stayed in frame.
 */
export function shouldStartOcrCountdown({
  autoOcrEnabled,
  plate,
  isBlocked,
  countdownRunning,
  pendingPlate,
}) {
  if (!autoOcrEnabled || !plate) return false;
  if (isBlocked) return false;
  if (countdownRunning) return false;
  if (pendingPlate === plate) return false;
  return true;
}

/** Kiosk / legacy flows — longer tolerance while models warm up. */
export const OCR_REQUEST_TIMEOUT_MS = 60000;

/** Detection page — allow model warmup on first scan; manual entry remains available. */
export const OCR_DETECTION_TIMEOUT_MS = 25000;
